import React, { useState, useEffect, } from "react";
import GenericTable from "./GenericTable";
import { toast } from 'react-toastify';
import { FaDownload, FaEdit, FaTrash } from "react-icons/fa";
import { chapters } from "../../../../src/chapterConf.js";

const ChapterDataCount = () => {

    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredData, setFilteredData] = useState([]);
    const Chapters = Object.keys(chapters).map((chapter) => ({
        ChapterName: chapter,
        ...chapters[chapter]
    }))    
    useEffect(() => {
        setFilteredData(Chapters);
    }, []);

    const handleSerch = (event) => {
        event.preventDefault();
        if (!searchQuery.trim()) {
            setFilteredData(Chapters);
            return;
        }
        const FilteredResults = Chapters.filter((chapter) => {
            chapter.name.toLowerCase().includes(searchQuery.toLowerCase());
        });
        setFilteredData(FilteredResults);
    };

    const newHandleSearch = (name) => {
        setSearchQuery(name);
        setFilteredData(
            Chapters.filter((chapter) =>
                chapter.name.toLowerCase().includes(name.toLowerCase())
            )
        )
    }
    useEffect(() => {
        if (searchQuery === '') {
            setFilteredData(Chapters);
        }
    }, [searchQuery])

    const columnList = [
        {
            label: "Chapter",
            cell: (row, index) => index,
        },
        {
            label: "Related Industry",
            cell: (row) => row.industry?.length ? row.industry?.join(',') :"-" ,

        },
        {
            label: "Name",
            cell: (row) => row.name,
        },
        {
            label: "Description",
            cell: (row) => row.description,
        },
    ];

    const handleDownloadCSV = () => {
        if (filteredData.length === 0) {
            toast.error("No data available to download.");
            return;
        }
    
        const csvHeader = ["Chapter", "Related Industry", "Name", "Description"].join(",") + "\n";

        const csvRows = filteredData.map(row => [
            `"${row.ChapterName}"`, 
            `"${row.industry?.join(", ") || "-"}"`, 
            `"${row.name}"`, 
            `"${row.description}"`
        ].join(",")).join("\n");
        const csvContent = csvHeader + csvRows;
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
    
        link.href = url;
        link.download = "chapter_config.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
        toast.success("CSV file downloaded successfully!");
    };
    

    return (
        <div>
            <div style={{ display: "flex", marginBottom: "1%" }}>
                <form onClick={handleSerch} style={{ width: "100%", display: "flex", alignItems: "center" }}>
                    <input
                        type="text"
                        placeholder={`Search by  name`}
                        value={searchQuery}
                        onChange={(e) => newHandleSearch(e.target.value)}
                        style={{ width: "60%", marginRight: 20, padding: "8px", borderRadius: "5px", border: "1px solid gray" }}
                    />
                </form>

                <div
                    type="submit"
                    onClick={handleDownloadCSV}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: 7,
                        backgroundColor: "#4b38b3",
                        color: "white",
                        borderRadius: 4,
                        cursor: "pointer",
                    }}
                >
                    <FaDownload style={{ fontSize: 16 }} />
                    <span>Download</span>
                </div>
            </div>
            <GenericTable
                {...{
                    columnList,
                    data: filteredData,
                }}
            />
        </div>
    );
};

export default ChapterDataCount;